<div>
  <button
    tuiButton
    [appearance]="'primary'"
    [class.default]="apiStatus === 'default'"
    [class.failed]="apiStatus === 'failed'"
    [class.loading]="apiStatus === 'loading'"
    [class.success]="apiStatus === 'success'"
    [class]="class"
    [disabled]="disabled"
    [icon]="icon"
    [iconRight]="iconRight"
    [nativeId]="id"
    [shape]="shape"
    [showLoader]="showLoader"
    [size]="size"
    [style]="styles"
    [type]="'button'"
    (click)="handleOnClick($event)"
  >
    {{ label }}
  </button>

  <kwikui-messages
    *ngIf="isShowApiTimerMessage"
    [id]="id"
    [messages]="apiTimerMessages"
  ></kwikui-messages>
</div>
